module.exports = __webpack_public_path__ + "img/img.6fa79919.png";